import { Visit } from '@precheckin/models/visit/visit.model';

export interface IPreCheckinVisitStateModel {
  isVisitReady: boolean;
  visit: Visit;
  showMessage: boolean;
  qrCode: string;
  displaySurvey: boolean;
  isNewVisit: boolean;
}

export const defaultVisitState = {
  isVisitReady: false,
  visit: new Visit(),
  showMessage: false,
  qrCode: '',
  displaySurvey: false,
  isNewVisit: false
} as IPreCheckinVisitStateModel;
